import { useContext, useEffect, useState } from "react";
import { Button, Container, Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { API } from "../../../../global/global";
import { AuthContext } from "../../../../context/AuthContext";
import { PlataformasxUsuarioInterface } from "../../../../interfaces/PlataformasxUsuario";
import SuccessMessage from "../../../Mensajes/SuccessMessage";

// Instancia limpia sin interceptores para evitar filtro de plataforma_activa
const axiosClean = Axios.create();

//estilos
const classes = require("./UsuarioAsignar.module.css").default;

const UsuarioAsignar = () => {
  const { idUsuario } = useParams();
  const authContext = useContext(AuthContext);
  const [plataformas, setPlataformas] =
    useState<PlataformasxUsuarioInterface[]>();
  const [show, setShow] = useState(false);

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + authContext.token,
  };

  //Función que trae todas las plataformas y marca las asignadas al usuario
  useEffect(() => {
    Promise.all([
      axiosClean.get(`${API}/plataforma`, { headers }),
      axiosClean.post(`${API}/plataformas_usuario`, { usuario_id: Number(idUsuario) }, { headers }),
    ]).then(([allRes, userRes]) => {
      const todas: PlataformasxUsuarioInterface[] = allRes.data.data;
      const asignadas: PlataformasxUsuarioInterface[] = userRes.data.data || [];
      // Marcar con pivot las que el usuario ya tiene asignadas
      const merged = todas.map((p) => {
        const asignada = asignadas.find((a) => a.id === p.id);
        if (asignada && asignada.pivot) {
          return asignada;
        }
        return { ...p, pivot: undefined };
      });
      setPlataformas(merged);
    }).catch(() => {
      // Si falla plataformas_usuario, al menos mostrar todas sin marcar
      axiosClean.get(`${API}/plataforma`, { headers })
        .then((res) => setPlataformas(res.data.data));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idUsuario]);

  //Actualizar plataformas
  const guardarPlataformas = (event: any) => {
    event.preventDefault();
    axiosClean
      .post(
        `${API}/saveplataformas_usuario`,
        { usuario_id: idUsuario, plataformas: plataformas },
        { headers }
      )
      .then(() => {
        setShow(true);
        window.scrollTo(0, 0);
      });
  };

  //Mientras se carga el contenido se muestra un spinner
  if (!plataformas) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h1>Lista de plataformas para el usuario {idUsuario}</h1>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Plataformas asignadas"
          body="Se han asigando las plataformas de manera correcta"
          onCloseHandler={() => setShow(false)}
        />
      )}
      <Form onSubmit={guardarPlataformas}>
        {plataformas.map((plataforma, index) => (
          <div key={plataforma.id} className="mb-3">
            <Form.Check
              type={"switch"}
              id={`switch-${plataforma.id}`}
              label={plataforma.nombre}
              style={{ textAlign: "left" }}
              defaultChecked={plataforma.pivot ? true : false}
              onChange={(event) => {
                if (event.target.checked) {
                  plataformas[index]["pivot"] = {
                    plataforma_id: plataforma.id,
                    usuario_id: +idUsuario!,
                  };
                } else {
                  delete plataformas[index]["pivot"];
                }
              }}
            />
          </div>
        ))}
        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
            marginBottom: "20px",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default UsuarioAsignar;
